import { getCookieValue, LANG_PREF_COOKIE } from '../../utils/languagePreference'
import { LANGUAGE_OPTIONS } from '../LanguageSwitcher/languages'

function isSupported(code: string | null | undefined): boolean {
  return !!code && LANGUAGE_OPTIONS.some(o => o.value === code)
}

/**
 * Which language's break the Break block should render.
 *
 * The page's own locale wins. On a locale-prefixed site the page was built at /es/...,
 * so that is the language the URL advertises and the language the rest of the page is
 * already rendering in. Reading the cookie first put an English break inside a Spanish
 * page for anyone arriving on a shared link without one.
 *
 * The cookie is the fallback, for a page with no locale of its own: a site that serves
 * one page in several languages, and the editor, where there is no URL to read from.
 *
 * Note both values here are page languages (`en`, `es`), not break languages. A break
 * is stored as `en-US` whichever language its content is written in, so a region
 * qualified value arriving here is a mistake and is ignored rather than matched loosely.
 */
export function resolveCurrentLanguage(pageLocale?: string | null): string {
  if (isSupported(pageLocale)) return pageLocale as string

  const cookie = getCookieValue(LANG_PREF_COOKIE)
  if (isSupported(cookie)) return cookie as string

  return LANGUAGE_OPTIONS[0]?.value ?? 'en'
}
